/**
 * Gets the sort key for a string by removing leading articles (the, a, an)
 * @param name - The name to get the sort key for
 * @returns The name without leading articles for proper alphabetical sorting
 */
export const getSortKey = (name: string): string => {
  const articles = ['the ', 'a ', 'an '];
  const lowerName = name.toLowerCase();

  for (const article of articles) {
    if (lowerName.startsWith(article)) {
      return name.substring(article.length);
    }
  }

  return name;
};

/**
 * Compares two strings alphabetically, ignoring leading articles
 * @param a - First string to compare
 * @param b - Second string to compare
 * @returns Comparison result for sorting
 */
export const compareAlphabetically = (a: string, b: string): number => {
  return getSortKey(a).localeCompare(getSortKey(b));
};

/**
 * Compares two objects by a string property alphabetically, ignoring leading articles
 * @param a - First object
 * @param b - Second object
 * @param key - Property name to compare
 * @returns Comparison result for sorting
 */
export const compareByProperty = <T>(a: T, b: T, key: keyof T): number => {
  const aValue = a[key];
  const bValue = b[key];

  if (typeof aValue === 'string' && typeof bValue === 'string') {
    return compareAlphabetically(aValue, bValue);
  }

  return 0;
};
